import {FieldName, routeDestinationPrefixName, routeSourceName} from '../../../../../lib/fieldNames'
import type {Props} from '../types'

export function useAddressWidgetProps({config: props}: Props) {
  const isSource = props.route_point_index === 0 // если это первая точка в пути, то это точка отправления ("Откуда")
  const pointId = isSource ? routeSourceName : `${routeDestinationPrefixName}${props.route_point_index}`
  const addressName = `${FieldName.Route}.${pointId}.address`
  const contactsName = `${FieldName.Contacts}.${props.route_point_index}`

  return {
    isSource,
    pointId,
    addressName,
    contactsName,
  } as const
}
